import React, { useState, useEffect } from 'react';

const BlogPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://habitatinclusion.com/blog/wp-json/wp/v2/posts?per_page=2&_embed');
        
        if (!response.ok) {
          throw new Error('Error al cargar los posts');
        }
        
        const data = await response.json();
        setPosts(data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching posts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const getExcerpt = (content, maxLength = 150) => {
    const text = stripHtml(content);
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  if (loading) {
    return (
      <div className="col-md-12 col-sm-12 mt-4 text-center">
        <p className="mitexto">Cargando posts del blog...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="col-md-12 col-sm-12 mt-4 text-center">
        <p className="mitexto" style={{ color: 'red' }}>
          Error al cargar los posts: {error}
        </p>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="col-md-12 col-sm-12 mt-4 text-center">
        <p className="mitexto">No hay posts disponibles</p>
      </div>
    );
  }

  return (
    <>
      {posts.map((post, index) => (
        <div key={post.id} className={`col-md-6 col-sm-12 mt-4 mb-5 text-center`}>
          {/* Imagen destacada */}
          {post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0] && (
            <img
              src={post._embedded['wp:featuredmedia'][0].source_url}
              alt={post.title.rendered}
              className="img-vertical"
              style={{ width: "100%" }}
            />
          )}
          
          {/* Fecha */}
          <p className="mitexto text-left">Fecha: {formatDate(post.date)}</p>
          
          {/* Autor */}
          {post._embedded && post._embedded.author && post._embedded.author[0] && (
            <p className="mitexto text-left" style={{ fontSize: 15 }}>
              Autor: {post._embedded.author[0].name}
            </p>
          )}
          
          {/* Título */}
          <p className="mitexto text-left">
            <strong>{post.title.rendered}</strong>
            <br />
            {getExcerpt(post.excerpt.rendered)}
          </p>

          {/* Botón Ver noticia */}
          <div className="more-news-link">
            <a href={post.link} target="_blank" rel="noopener noreferrer">
              <button className="contact-button">Ver noticia</button>
            </a>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlogPosts;

